module.exports = __webpack_public_path__ + "static/media/author_img_4.b22614c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/author_img_4.png
// module id = 780
// module chunks = 0